// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBlockAccordion_wrapper__UB6xq"};